import { Injectable } from '@angular/core';
import { InvoiceModel } from '../../../models/consultation/cash-sale.model';
@Injectable()
export class InvoiceService {
    constructor() {

    }
}

export const InvoiceList: InvoiceModel[] = [
    {
        patientref: "TES10016HC",
        fullname: "patient 9 test",
        dateOfbirth: "14 Jan 1989",
        invoiceno: "10013HC", 
        invoicedate: "28/09/2017",
        invoiceto:"",
        orderno:""
    },
   
];





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/invoice.service.ts